import { mapState, mapActions } from 'vuex';
  
  export default {
    computed: {
      ...mapState({
        loading(state) { return state.loading; }
      }),
      ...mapState('loginStore', {
        loginInfo(state) { return state.loginInfo; }
      }),

      dadosInvalidos() {
        return (this.loginInfo.login.length != 14  || this.loginInfo.senha.length == 0  || this.loginInfo.imobiliaria.id.length == 0);
      }
    },
    methods: {
      ...mapActions([
        'showLoading',
        'hideLoading'
      ]),
      ...mapActions('loginStore', [
        'validarAcesso',
      ]),
      logarHandler() {
        if(this.dadosInvalidos) {
          this.$message.error("Preencha todos os campos");
          return;
        }
        this.logar();
      },
      logar() {
        this.showLoading();
        this.validarAcesso(this.loginInfo)
        .then((resultado) => {
          switch(resultado.status) {
            case "SUCESSO":
              this.$router.push("/dashboard");
              break;
            default:
              this.$message.warning(resultado.mensagem);
          }
          this.hideLoading();
        }).catch(() => {
          this.hideLoading();
          this.$message.error('Não foi possível conectar-se ao servidor');          
        });
      }
    }
  }